import { apiRequest, buildURL } from './commons/CommonService.Functions';

// models
import {
  AddressViewModel,
  CreatePersonAddressCommand,
  UpdatePersonAddressCommand
} from '../models/Entities/Person/Address/AddressModels';

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'persons';

// Get all addresses of a person
export const GetAddressesByPersonId = async (
  token: string,
  personId: number
): Promise<AddressViewModel[]> => {
  const requestUrl: string = buildURL(BaseURL, personId, 'addresses');
  return apiRequest<AddressViewModel[]>(requestUrl, token, 'GetAddressesByPersonId');
};

// Get address by id
export const GetAddressById = async (
  token: string,
  addressId: number
): Promise<AddressViewModel> => {
  const requestUrl: string = buildURL(BaseURL, 'addresses', addressId);
  return apiRequest<AddressViewModel>(requestUrl, token, 'GetAddressById');
};

// Create address
export const CreateAddress = async (
  token: string,
  payload: CreatePersonAddressCommand
): Promise<AddressViewModel> => {
  const requestUrl: string = buildURL(BaseURL, 'addresses');
  return apiRequest<AddressViewModel>(requestUrl, token, 'CreateAddress', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

// Update address
export const UpdateAddress = async (
  token: string,
  payload: UpdatePersonAddressCommand
): Promise<AddressViewModel> => {
  const requestUrl: string = buildURL(BaseURL, 'addresses');
  return apiRequest<AddressViewModel>(requestUrl, token, 'UpdateAddress', {
    method: 'PUT',
    body: JSON.stringify(payload)
  });
};

// Delete address
export const DeleteAddress = async (
  token: string,
  addressId: number
): Promise<number> => {
  const requestUrl: string = buildURL(BaseURL, 'addresses', addressId);
  return apiRequest<number>(requestUrl, token, 'DeleteAddress', {
    method: 'DELETE'
  });
};
